import { useContext } from "react";
import { Grid } from "@mui/material";
import "./nextHeader.css";
import { AuthContext } from "../../../../../../../contexts";
import { formatSSN } from "../../../../../../../utils/commonFunctions/SSN";
import { formatZIP } from "../../../../../../../utils/commonFunctions/ZIP";

interface NextSectionProps {
	isPrintable: boolean;
}

// eslint-disable-next-line react/prop-types
const NextSection = ({ isPrintable }: NextSectionProps) => {
	const { member } = useContext(AuthContext);

	// console.log("member===>", member);

	if (member === null) {
		return <></>;
	}

	return (
		<>
			<div className={isPrintable ? "gli-next-header-container-print font-size-md" : "gli-next-header-container"}>
				<Grid container spacing={1}>
					<Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="gli-next-header display-flex">
						<div className={isPrintable ? "font-size-sm" : "header-label"}>Group Policyholder Name:</div>
						<div className={isPrintable ? "font-size-sm" : "header-value"}>
							Brookshire Brothers Inc. (Group ID: BROOKSHIR)
						</div>
					</Grid>
					<Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="gli-next-header border-right display-flex">
						<div className={isPrintable ? "font-size-sm" : "header-label"}>Group Policy Number(s)</div>
						<div className={isPrintable ? "font-size-sm" : "header-value"}>000010251882</div>
					</Grid>
				</Grid>
				<Grid container spacing={1}>
					<Grid
						item
						xs={6}
						sm={6}
						md={6}
						lg={6}
						xl={6}
						className="gli-next-header border-bottom display-flex"
					>
						<div className={isPrintable ? "font-size-sm" : "header-details-label"}>
							Employee Name and Address (Street, City, State):
						</div>
						<div className={isPrintable ? "font-size-sm" : "header-details-value"}>
							{member?.first_name} {member?.last_name}
							{member?.ZIP
								? `, ${member?.address_line_1}, ${member?.city}, ${member?.state}, ${formatZIP(
										member.ZIP
								  )}`
								: null}
						</div>
					</Grid>

					<Grid
						item
						xs={6}
						sm={6}
						md={6}
						lg={6}
						xl={6}
						className="gli-next-header border-bottom border-right display-flex"
					>
						<div className={isPrintable ? "font-size-sm" : "header-details-label"}>Employee ID Number</div>
						<div className={isPrintable ? "font-size-sm" : "header-details-value"}>{member?.member_id}</div>
					</Grid>
				</Grid>
			</div>
			<div className={isPrintable ? "beneficary-section-print" : "beneficary-section"}>
				{/* {isPrintable ? (
					<p className="font-size-large">
						<b>WHO ARE YOUR BENEFICIARIES?</b>
					</p>
				) : (
					<h2 className="beneficary-header">WHO ARE YOUR BENEFICIARIES?</h2>
				)} */}
				<p
					className={isPrintable ? "beneficary-paragraph font-size-medium" : "beneficary-paragraph"}
					style={{ textAlign: "justify" }}
				>
					Subject to the terms of the above numbered Group Policy(ies), I request that any sum becoming
					payable by reason of my death be payable to the following beneficiary(ies). It is my understanding
					that this designation shall operate so as to revoke all designations of beneficiary and all
					elections of optional methods of settlement previously made by me under said Policy(ies). If this
					Designation of Beneficiary refers only to a Group Life Insurance Policy and if I am also insured for
					Supplemental and/or Group Accidental Death coverage, this designation shall apply to those
					coverages. This Designation of Beneficiary is subject to all “Conditions” shown on the reverse side
					of this form.
				</p>
			</div>
		</>
	);
};

export default NextSection;
